import { render } from "./OptionButtons.vue?vue&type=template&id=110f8b4d&scoped=true"
import script from "./OptionButtons.vue?vue&type=script&lang=js"
export * from "./OptionButtons.vue?vue&type=script&lang=js"

import "./OptionButtons.vue?vue&type=style&index=0&id=110f8b4d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-110f8b4d"

export default script